<template>
  <div class="contact-page">
    <header class="contact-hero">
      <span class="contact-icon">✉️</span>
      <h1>تماس با ما</h1>
      <p class="contact-sub">
        برای همکاری، تبلیغات، گزارش خطای آماری یا پیشنهاد موضوع برای
        «دانستنی‌های فوتبالی»، مستقیم به ایمیل ما بنویسید؛ همهٔ پیام‌ها خوانده می‌شود.
      </p>
    </header>

    <section class="email-card">
      <span class="email-label">ایمیل رسمی ضربه آزاد</span>
      <a
          class="email-value"
          href="mailto:hoseinkhodayarian@gmail.com"
          dir="ltr"
      >hoseinkhodayarian@gmail.com</a>
      <button
          type="button"
          class="copy-btn"
          @click="copyEmail"
      >{{ copied ? '✓ کپی شد' : 'کپی ایمیل' }}</button>
    </section>

    <section class="contact-topics">
      <h2>چه موضوعاتی را بنویسید؟</h2>
      <div class="topics-grid">
        <div class="topic-card">
          <span class="topic-icon">🤝</span>
          <h3>همکاری و تبلیغات</h3>
          <p>درخواست تبلیغ در صفحات سایت، اسپانسرشدن بخش‌ها و پیشنهادهای همکاری تجاری؛ لطفاً موضوع و بازهٔ زمانی را بنویسید.</p>
        </div>
        <div class="topic-card">
          <span class="topic-icon">🔍</span>
          <h3>گزارش خطا</h3>
          <p>اگر آمار، نتیجه یا جدولی را نادرست دیدید، لینک همان صفحه و توضیح مشکل را بفرستید تا سریع بررسی و اصلاح شود.</p>
        </div>
        <div class="topic-card">
          <span class="topic-icon">💡</span>
          <h3>پیشنهاد دانستنی</h3>
          <p>فکت یا رکورد جالبی سراغ دارید که نباید از قلم بیفتد؟ موضوع پیشنهادی شما بررسی می‌شود و پس از راستی‌آزمایی منتشر خواهد شد.</p>
        </div>
        <div class="topic-card">
          <span class="topic-icon">📝</span>
          <h3>سایر موضوعات</h3>
          <p>پیشنهاد بهبود بخش‌های سایت، درخواست پوشش مسابقات خاص یا هر مطلب دیگری که برایتان مهم است.</p>
        </div>
      </div>
    </section>

    <p class="contact-note">
      ضربه آزاد یک پروژهٔ رسانه‌ای مستقل است؛ سریع‌ترین راه ارتباطی با تیم،
      همین ایمیل است و پاسخ‌گویی معمولاً ظرف چند روز انجام می‌شود.
    </p>
  </div>
</template>

<script>
import { setSeo } from '@/utils/seo'

const CONTACT_EMAIL = 'hoseinkhodayarian@gmail.com'

export default {
  name: 'ContactView',

  data() {
    return {
      copied: false,
    }
  },

  created() {
    setSeo({
      title: 'تماس با ما | ضربه آزاد',
      description: 'ایمیل رسمی تماس با ضربه آزاد: hoseinkhodayarian@gmail.com — همکاری و تبلیغات، گزارش خطای آماری و پیشنهاد موضوع برای دانستنی‌های فوتبالی',
      path: '/contact',
    })
  },

  methods: {
    async copyEmail() {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(CONTACT_EMAIL)
        } else {
          const ta = document.createElement('textarea')
          ta.value = CONTACT_EMAIL
          ta.style.position = 'fixed'
          ta.style.opacity = '0'
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
        this.copied = true
        clearTimeout(this._copiedTimer)
        this._copiedTimer = setTimeout(() => { this.copied = false }, 2200)
      } catch (e) { /* بی‌صدا — لینک mailto همیشه کار می‌کند */ }
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/variables';
@import '@/assets/sass/mixin';

.contact-page {
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 12px 48px;
}

// ---------- هیرو ----------
.contact-hero {
  text-align: center;
  padding: 36px 16px 24px;

  .contact-icon {
    font-size: 44px;
    display: inline-block;
    margin-bottom: 10px;
  }

  h1 {
    margin: 0 0 10px;
    font-size: 26px;
    color: #111827;
  }
}

.contact-sub {
  color: #6b7280;
  font-size: 15px;
  margin: 0 auto;
  max-width: 520px;
  line-height: 1.9;
}

// ---------- کارت ایمیل ----------
.email-card {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 16px;
  box-shadow: $shadow-sm;
  padding: 26px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 8px 0 22px;
}

.email-label {
  color: #6b7280;
  font-size: 13px;
  font-weight: 700;
}

.email-value {
  color: $red;
  font-size: 20px;
  font-weight: 800;
  text-decoration: none;
  letter-spacing: 0; // روی ایمیل فارسی فاصله‌گذاری حروف ممنوع
  word-break: break-all;

  &:hover {
    text-decoration: underline;
    color: $red-dark;
  }
}

.copy-btn {
  background: $gray-50;
  border: 1px solid $gray-300;
  color: #374151;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 22px;
  border-radius: 999px;
  cursor: pointer;
  transition: all .15s;

  &:hover {
    background: $gray-100;
    border-color: $gray-400;
  }
}

// ---------- موضوعات ----------
.contact-topics {
  h2 {
    margin: 0 0 14px;
    font-size: 17px;
    color: #111827;
  }
}

.topics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.topic-card {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 14px;
  padding: 18px 16px;
  box-shadow: $shadow-sm;

  .topic-icon {
    font-size: 24px;
    display: inline-block;
    margin-bottom: 8px;
  }

  h3 {
    margin: 0 0 6px;
    font-size: 14.5px;
    color: #111827;
  }

  p {
    margin: 0;
    color: #6b7280;
    font-size: 13px;
    line-height: 1.95;
    text-align: justify;
  }
}

.contact-note {
  margin: 20px 4px 0;
  color: #9ca3af;
  font-size: 12.5px;
  line-height: 1.9;
  text-align: center;
}

// ---------- رسپانسیو ----------
@media (max-width: 768px) {
  .contact-page {
    padding: 12px 8px 36px;
  }

  .contact-hero {
    padding: 22px 6px 16px;

    h1 { font-size: 22px; }
  }

  .contact-sub { font-size: 13.5px; }

  .email-card {
    padding: 20px 14px;
  }

  .email-value { font-size: 16px; }

  .topics-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
</style>
